import { type ClipSpriteSheet } from '@air/api/types';

/**
 * Gets the number of columns in the spritesheet.
 * @param spritesheet
 * @returns the number of columns, or 0 if spritesheet is undefined
 */
export const getClipSpritesheetColumns = (spritesheet: ClipSpriteSheet | undefined) => {
  if (!spritesheet) {
    return 0;
  }

  return spritesheet.columns;
};
